import { AfterViewInit, Component, ElementRef, Input, OnDestroy, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

@Component({
  selector: 'app-figma-benin-story',
  templateUrl: './figma-benin-story.component.html',
  styleUrls: ['./figma-benin-story.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class FigmaBeninStoryComponent implements AfterViewInit, OnDestroy {
  @Input() backgroundImage = '';
  @Input() eyebrow = '';
  @Input() title = '';
  @Input() paragraphs: string[] = [];

  @ViewChild('storySection') storySection!: ElementRef<HTMLElement>;

  private ctx?: gsap.Context;

  ngAfterViewInit(): void {
    gsap.registerPlugin(ScrollTrigger);

    this.ctx = gsap.context(() => {
      const motionMedia = gsap.matchMedia();

      motionMedia.add('(prefers-reduced-motion: no-preference)', () => {

        gsap.from('.benin-story__card', {
          scrollTrigger: {
            trigger: '.benin-story__card',
            start: 'top 85%',
          },
          y: 50,
          opacity: 0,
          duration: 1,
          ease: 'power3.out'
        });

        const elementsToStagger = [
          '.benin-story__card h2',
          '.benin-story__eyebrow',
          '.benin-story__copy p'
        ];

        gsap.from(elementsToStagger, {
          scrollTrigger: {
            trigger: '.benin-story__card',
            start: 'top 80%',
          },
          y: 20,
          opacity: 0,
          duration: 0.8,
          stagger: 0.1,
          ease: 'power2.out',
          delay: 0.2
        });
      });
    }, this.storySection?.nativeElement);
  }

  ngOnDestroy(): void {
    this.ctx?.revert();
  }
}

